<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="card-group mb-0">
                        <div class="card p-4">
                            <div class="card-body" :key="$route.params.id">
                                <h1>Reset Password</h1>
                                <p v-bind:class="{ 'text-muted': !data.resetError, 'error-text': data.resetError }">{{data.resetMessage}}</p>
                                <div class="input-group mb-3">
                                    <span class="input-group-addon"><i class="icon-envelope"></i></span>
                                    <input disabled v-model="data.body.username" type="text" class="form-control" placeholder="Email">
                                </div>
                                <div class="input-group mb-4">
                                    <span class="input-group-addon"><i class="icon-lock"></i></span>
                                    <input v-model="data.body.password" type="password" class="form-control" placeholder="Password">
                                </div>
                                <div class="input-group mb-4">
                                    <span class="input-group-addon"><i class="icon-lock"></i></span>
                                    <input v-model="data.body.resetPassword" type="password" class="form-control" placeholder="Reset Password">
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <button v-on:click="resetPasswordFunc()" type="button" class="btn btn-primary px-4">Reset Password</button>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="card text-white bg-dark py-5 d-md-down-none" style="width:44%">
                                <div class="card-body text-center">
                                    <div>
                                    <img src="./wc.png">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data () {
    return {
      context: 'login context',
      data: {
        body: {
          username: '',
          password: '',
          resetPassword: ''
        },
        resetMessage: 'Reset your Password.',
        resetError: false,
        isHttpRequest: true
      }
    }
  },
  methods: {
    resetPasswordFunc () {
      // Makinng Error and Message to original State 
      this.data.resetError = false
      this.data.resetMessage = 'Reset your Password.'
      this.data.isHttpRequest = true
      console.log('resetPasswordFunc -> this.data.body', this.data.body)
      if (this.data.body.password === null || this.data.body.password === '' ||
        this.data.body.resetPassword === null || this.data.body.resetPassword === '' ||
        this.data.body.username === null || this.data.body.username === '') {
        this.data.resetError = true
        this.data.resetMessage = 'Please enter all fields as they are mandatory.'
        this.data.isHttpRequest = false
      }
      const {password, resetPassword, username} = this.data.body
      if (this.data.resetError === false && (!password.match(/[a-z]/g) || !password.match(/[A-Z]/g) || !password.match(/[0-9]/g) || !password.match(/[^a-zA-Z\d]/g) || password.length <= 8)) {
        this.data.resetError = true
        this.data.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.'
        this.data.isHttpRequest = false
      }
      if (this.data.resetError === false && (password !== resetPassword)) {
        this.data.resetError = true
        this.data.resetMessage = 'Both Password should be Same !!'
        this.data.isHttpRequest = false
      }
      if (this.data.isHttpRequest) {
        console.log('resetPasswordFunc -> username', username)
        var requestBody = {
          'token_mail': this.$route.query.test,
          'email': username,
          'password_hash': password
        }
        this.$http.post('auth/setResetPassword', requestBody).then(response => {
          console.log(this.$router, response)
          if (response && response.status === 200) {
            this.$router.push({path: '/login'})
          }
        }, response => {
          console.log(response)
        })
      }
    }
  },
  created () {
    console.log('The id is: ' + this.$route.params.id)
    this.$http.post('auth/getMailId', {'token_mail': this.$route.query.test}).then(response => {
      if (response.status === 200 && (response.body.user !== null && response.body.user !== undefined)) {
        console.log('11001' + response)
        this.data.body.username = response.body.user
      } else {
        this.data.resetError = true
        this.data.resetMessage = response.body.message
      }
    }, response => {
      console.log(response)
    })
  }
}
</script>

<style>
.error-text {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/resetPassword/ResetPassword.vue